@if (form(); as form) {
  <fieldset [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <app-alert class="d-inline-block" [closable]="false">
          Zaznacz obszary o których chcesz dostawać powiadomienia.
        </app-alert>
      </div>
    </div>
    <ul class="row">
      @for (area of form.areas; track $index) {
        <li class="col-12">
          <div class='form-group mb-0 pb-0'>
            <div class='custom-checkbox custom-inline'>
              <input
                [attr.aria-describedby]="area?.uuid + 'Desc'"
                [formControlName]="area.uuid || ''"
                type='checkbox'
                [id]='area?.uuid'>
              <label [for]='area?.uuid'>
                {{ area?.name || '' }}
              </label>
            </div>
          </div>
          <div [id]="area.uuid + 'Desc'" class="mb-4">
            <small>
              {{ area?.streetList }}
            </small>
          </div>
        </li>
      }
    </ul>
  </fieldset>
}
